export const GET_STATISTICS_WINNERS = "GET_STATISTICS_WINNERS";